module.exports = __webpack_public_path__ + "static/img/6.7b177f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/6.png
// module id = GkYF
// module chunks = 35